import { render, staticRenderFns } from "./ed-class-builder-placeholders-modal.component.vue?vue&type=template&id=98dedbf6&scoped=true&"
import script from "./ed-class-builder-placeholders-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-placeholders-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-placeholders-modal.component.scss?vue&type=style&index=0&id=98dedbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dedbf6",
  null
  
)

export default component.exports